import { render, staticRenderFns } from "./SlideCopy.vue?vue&type=template&id=61df3139&scoped=true&"
import script from "./SlideCopy.vue?vue&type=script&lang=js&"
export * from "./SlideCopy.vue?vue&type=script&lang=js&"
import style0 from "./SlideCopy.vue?vue&type=style&index=0&id=61df3139&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61df3139",
  null
  
)

export default component.exports